// Initialize and add the map
var map;


window.initMap = function(){
    var map = new google.maps.Map(document.getElementById('map'), {
        // USA
        zoom: 4,
        center: { lat: 39.7634295, lng: -96.3845439 }

        // Bay Area
        //zoom: 6,
        //center: {lat: -33.9, lng: 151.2}
    });
    var villages = $('.villages_infos').data('villages')
    var geocoder = new google.maps.Geocoder();
    var markers = setMarkers(map, villages);

    geocodeAddress(geocoder, map, "state");

}
// Data for the markers consisting of a name, a LatLng and a zIndex for the
// order in which these markers should display on top of each other.


function setMarkers(map, villages) {
    // Adds markers to the map.

    // Marker sizes are expressed as a Size of X,Y where the origin of the image
    // (0,0) is located in the top left of the image.

    // Origins, anchor positions and coordinates of the marker increase in the X
    // direction to the right and in the Y direction down.
    var image = {
        //url: 'https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png',
        url: '/helpfulvillage-logo-58x58.png',
        // This marker is 20 pixels wide by 32 pixels high.
        size: new google.maps.Size(58, 58),
        // The origin for this image is (0, 0).
        origin: new google.maps.Point(0, 0),
        // The anchor for this image is the base of the flagpole at (0, 32).
        anchor: new google.maps.Point(0, 32)
    };
    // Shapes define the clickable region of the icon. The type defines an HTML
    // <area> element 'poly' which traces out a polygon as a series of X,Y points.
    // The final coordinate closes the poly by connecting to the first coordinate.
    var shape = {
        //coords: [1, 1, 1, 20, 18, 20, 18, 1],
        coords: [0, 0, 55, 55],
        type: 'rect'
    };
    var markers = [];
    for (var i = 0; i < villages.length; i++) {
        var village = villages[i];
        var marker = new google.maps.Marker({
            position: { lat: parseFloat(village[1]), lng: parseFloat(village[2]) },
            map: map,
            icon: image,
            shape: shape,
            title: village[0],
            zIndex: 5
        });

        google.maps.event.addListener(marker, 'click', handleMarkerClick.bind(undefined, marker, villages[i]));

        markers.push(marker);
    }
    return markers;
}


function geocodeAddress(geocoder, resultsMap, gotoMethod) {
    var address;
    //if (gotoMethod == 'state') {
    //    address = document.getElementById("state").value;
    //} else {
    //    address = document.getElementById("address").value;
    //}

    address = document.getElementById("selected_place").value;
    if (address != "") {
    
        geocoder.geocode({ 'address': address }, function (results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
                resultsMap.setCenter(results[0].geometry.location);
                /*var marker = new google.maps.Marker({
                    map: resultsMap, 
                        position: results[0].geometry.location
                    });*/
                if (results[0].geometry.viewport)
                    resultsMap.fitBounds(results[0].geometry.viewport);
            } else {
                alert("Geocode was not successful for the following reason: " + status);
            }
        });
    }
}


function handleMarkerClick(marker, village) {

    //alert('handleMarker')

    var website = village[4];
    if (village[6] && village[6].length > 0){
      website = village[6];
    }


    if (typeof infowindow === 'undefined') {
        infowindow = new google.maps.InfoWindow({});
    }
    //var data = 'test' //infoCentros[index]//helpful data
    var data = '<div id="content">' +
        '<div id="siteNotice">' +
        '</div>' +
        '<h1 id="firstHeading" class="firstHeading">' + village[0] + '</h1>' +
        '<div id="bodyContent">' +
        '<p><b>' + village[0] + '</b> ' +
        village[3] +
        '</p>' +
        '<p>Website: <a href="' + website + '">' +
        website +
        '</p>' +
        '</div>' +
        '</div>';


    //create content with dynamic data 
    infowindow.setContent(data);
    infowindow.open(marker.getMap(), marker);//modify as per your requirement
}



//$(document).on('turbolinks:load', function() {
//    var $state_select = $('#state');

    //$state_select.on('change', function () {
    //    alert($state_select.val());
    //    geocodeAddress(geocoder, map, "state");
    //});

//});
